import { ISelectData } from 'components/atoms/SelectComponent';

import { ETypOsoby } from 'enums/lei/typOsoby';

export const leiTypOsobySelect: ISelectData[] = [
    {
        labelcz: 'LEI_TYP_OSOBY_OPRAVNENA_SELECT',
        value: ETypOsoby.OPRAVNENA
    },
    {
        labelcz: 'LEI_TYP_OSOBY_POVERENA_SELECT',
        value: ETypOsoby.POVERENA
    }
];
